module.exports = __webpack_public_path__ + "static/media/pmp.c75047fd.png";